module.exports = __webpack_public_path__ + "img/Glowkit-ShapeCustom.de8ce93a.jpg";